// extracted by mini-css-extract-plugin
export default {"speakers-select":"styles_speakers-select__Sug7l"};